import { Box, useTheme } from "@mui/material"
import { Head } from "components/Head"
import { AttractionCard } from "extensions/iconsiam/components/domains/attractions/Card"
import { Header } from "extensions/iconsiam/components/Header"
import { HeaderSearchButton } from "extensions/iconsiam/components/Header/HeaderSearchButton"
import { ATTRACTION_TYPE } from "extensions/iconsiam/constants"
import { PageLayout } from "extensions/iconsiam/layouts/PageLayout"
import { usePost } from "hooks/post/usePost"
import { useTranslation } from "providers/i18n"

export const AttractionsPage = ({ Layout = PageLayout }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { styleOverrides = {} } = theme.components?.[`AttractionPage`] || {}
  const { root } = styleOverrides
  const { hasData, postData: attractions } = usePost(ATTRACTION_TYPE)
  return (
    <>
      <Head title={t("Attractions")} />
      <Layout header={<Header searchButton={<HeaderSearchButton />} />}>
        <Box sx={root}>
          {hasData &&
            attractions.map((attraction, index) => (
              <AttractionCard data={attraction} key={`attraction-${index}`} />
            ))}
        </Box>
      </Layout>
    </>
  )
}
